import React, { useState, useEffect, useRef } from "react";
import { Button, Pagination } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";

const MaterialTable = (props: any) => {
	const { exportData, exportDataRegional, totalOpp } = props;
	const selectedRegions = props.selectedRegions;
	const [targetCost, setTargetCost] = useState<any>(null);
	const [inputFlag, setInputFlag] = useState<any>(null);

	const exportFullRef = useRef<any>(null);
	const exportFullRegionalRef = useRef<any>(null);

	console.log(exportData[0], exportDataRegional[0], 321);

	const [limit, setLimit] = React.useState(10);

	useEffect(() => {
		if (props.target !== "regional" && exportData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	}, [exportData]);

	useEffect(() => {
		if (props.target === "regional" && exportDataRegional?.length !== 0) {
			exportFullRegionalRef?.current?.link.click();
		}
	}, [exportDataRegional]);

	const exportExcel = () => {
		props?.getExportData();
	};

	useEffect(() => {
		setInputFlag(null);
		setTargetCost(null);
	}, [props.target]);

	const removeLeadingZero = (n: any) => {
		let newStr = n.replace(/^0+/, "");
		return newStr;
	};

	const validateNumbers = (e: any) => {
		return (e.target.value = e.target.value.replace(/[^\d.]/g, ""));
	};

	const handleCostChange = (
		e: any,
		materialIndex: any,
		regionIndex: any,
		districtIndex: any,
		k: any
	) => {
		setTargetCost(e.target.value);
		setInputFlag(k);
		props.updateSaveButton(true);

		const districtObject =
			props.data.data?.materials[materialIndex].Region[regionIndex]
				.Districts[districtIndex];
		const districtOpportunity =
			((districtObject.costPerUnit - e.target.value) *
			districtObject.LastYear_Qty)/2;

		const initialRegionalOpportuinity =
			props.data.data.materials[materialIndex].Region[regionIndex]
				.Districts[districtIndex].adjustedRegionalOpportunity;
		const initialNationalOpportuinity =
			props.data.data.materials[materialIndex].Region[regionIndex]
				.Districts[districtIndex].adjustedNationalOpportunity;

		const regionalOpportuinityDifference =
			(districtOpportunity > 0 ? districtOpportunity : 0) -
			initialRegionalOpportuinity;
		const nationalOpportuinityDifference =
			(districtOpportunity > 0 ? districtOpportunity : 0) -
			initialNationalOpportuinity;

		const region_regionOpportunity =
			props.data.data.materials[materialIndex].Region[regionIndex]
				.adjustedRegionalOpportunity + regionalOpportuinityDifference;
		const region_nationalOpportunity =
			props.data.data.materials[materialIndex].Region[regionIndex]
				.adjustedNationalOpportunity + nationalOpportuinityDifference;

		const material_regionOpportunity =
			props.data.data.materials[materialIndex]
				.adjustedRegionalOpportunity + regionalOpportuinityDifference;
		const material_nationalOpportunity =
			props.data.data.materials[materialIndex]
				.adjustedNationalOpportunity + nationalOpportuinityDifference;

		if (props.target === "regional") {
			props.data.data.materials[materialIndex].Region[
				regionIndex
			].Districts[districtIndex].adjustedRegionalTargetCost =
				e.target.value;
			props.data.data.materials[materialIndex].Region[
				regionIndex
			].Districts[districtIndex].adjustedRegionalOpportunity =
				districtOpportunity > 0 ? districtOpportunity : 0;

			props.data.data.materials[materialIndex].Region[
				regionIndex
			].adjustedRegionalOpportunity = region_regionOpportunity;
			props.data.data.materials[
				materialIndex
			].adjustedRegionalOpportunity = material_regionOpportunity;
		} else {
			props.data.data.materials[materialIndex].Region[
				regionIndex
			].Districts[districtIndex].adjustedNationalTargetCost =
				e.target.value;
			props.data.data.materials[materialIndex].Region[
				regionIndex
			].Districts[districtIndex].adjustedNationalOpportunity =
				districtOpportunity > 0 ? districtOpportunity : 0;

			props.data.data.materials[materialIndex].Region[
				regionIndex
			].adjustedNationalOpportunity = region_nationalOpportunity;
			props.data.data.materials[
				materialIndex
			].adjustedNationalOpportunity = material_nationalOpportunity;
		}
		if (
			!props.updatedMaterials.includes(
				props.data.data.materials[materialIndex].material
			)
		) {
			props.updateEditedtedMaterials([
				...props.updatedMaterials,
				props.data.data.materials[materialIndex].material,
			]);
		}
		props.handleChange(
			props.data.data.materials[materialIndex],
			props.data.data.materials[materialIndex].material
		);
	};

	return (
		<>
			<table className="common-table-ui">
				<thead>
					<tr>
						<th>Material No.</th>
						<th>Part Number</th>
						<th>Material Description</th>
						{props.selectedMaterial && <th>Regions</th>}
						{props.selectedRegions.length > 0 && <th>Districts</th>}
						<th>Quantity</th>
						<th>Spend</th>
						<th>Net Cost</th>
						<th>Target Cost</th>
						<th>
							Opportunity <br />
							<i className="text-[0.6vw] font-normal">
								(at 50% Capture Rate)
							</i>
						</th>
					</tr>
				</thead>
				<tbody>
					{props.data.data?.materials?.map(
						(d: any, materialIndex: any) => {
							return (
								<React.Fragment
									key={d.material + "_" + materialIndex}
								>
									<tr
										key={d.material}
										className={`${
											props.selectedMaterial ===
											d.material
												? "selected-row "
												: props.selectedMaterial !==
												  null
												? "low-opacity"
												: ""
										}`}
									>
										<td>
											<div className="flex">
												{props.selectedMaterial ===
												d.material ? (
													<MinusRoundIcon
														className="plusIcon"
														onClick={(e: any) => {
															props.updateSelectedMaterial(
																null
															);
															props.updateSelectedRegions(
																[]
															);
															// e.stopPropagation();
														}}
													/>
												) : (
													<PlusRoundIcon
														className="plusIcon"
														onClick={() => {
															props.updateSelectedMaterial(
																d.material
															);
															props.updateSelectedRegions(
																[]
															);
														}}
													/>
												)}

												<div>
													{removeLeadingZero(
														d.material
													)}
												</div>
											</div>
										</td>
										<td>{d.MAN_PART_NO}</td>
										<td className="description">
											{d.itemDesc}
										</td>
										{props.selectedMaterial && <td></td>}
										{props.selectedRegions.length > 0 && (
											<td></td>
										)}
										<td>
											{numberFormatter(d.LastYear_Qty, 0)}
										</td>
										<td>
											{numberFormatter(
												d.LastYear_Cost,
												0,
												"$"
											)}
										</td>
										<td>
											{numberFormatter(
												d.costPerUnit,
												2,
												"$"
											)}
										</td>
										<td>
											{props.target === "regional"
												? "-"
												: numberFormatter(
														d.adjustedNationalTargetCost,
														2,
														"$"
												  )}
										</td>
										<td>
											{props.target === "regional"
												? numberFormatter(
														d.adjustedRegionalOpportunity,
														0,
														"$"
												  )
												: numberFormatter(
														d.adjustedNationalOpportunity,
														0,
														"$"
												  )}
										</td>
									</tr>
									{props.selectedMaterial === d.material &&
										d.Region.map(
											(r: any, regionIndex: any) => {
												return (
													<>
														<tr
															key={
																d.material +
																"_" +
																r.Region
															}
															className={`${
																props.selectedRegions.includes(
																	r.Region
																)
																	? "selected-row "
																	: props
																			.selectedRegions
																			.length >
																	  0
																	? "low-opacity"
																	: ""
															}`}
														>
															<td></td>
															<td></td>
															<td></td>
															<td>
																<div className="flex">
																	{selectedRegions?.includes(
																		r.Region
																	) ? (
																		<MinusRoundIcon
																			className="plusIcon"
																			onClick={(
																				e: any
																			) => {
																				const temp =
																					selectedRegions;
																				const index =
																					temp.indexOf(
																						r.Region
																					);
																				temp.splice(
																					index,
																					1
																				);
																				props.updateSelectedRegions(
																					[
																						...temp,
																					]
																				);
																				// e.stopPropagation();
																			}}
																		/>
																	) : (
																		<PlusRoundIcon
																			className="plusIcon"
																			onClick={() => {
																				props.updateSelectedRegions(
																					[
																						...props?.selectedRegions,
																						r.Region,
																					]
																				);
																			}}
																		/>
																	)}
																	<div>
																		{
																			r.Region
																		}
																	</div>
																</div>
															</td>
															{props
																.selectedRegions
																.length > 0 && (
																<td></td>
															)}
															<td>
																{numberFormatter(
																	r.LastYear_Qty,
																	0
																)}
															</td>
															<td>
																{numberFormatter(
																	r.LastYear_Cost,
																	0,
																	"$"
																)}
															</td>
															<td>
																{numberFormatter(
																	r.costPerUnit,
																	2,
																	"$"
																)}
															</td>
															<td>
																{props.target ===
																"regional"
																	? numberFormatter(
																			r.adjustedRegionalTargetCost,
																			2,
																			"$"
																	  )
																	: numberFormatter(
																			r.adjustedNationalTargetCost,
																			2,
																			"$"
																	  )}
															</td>
															<td>
																{props.target ===
																"regional"
																	? numberFormatter(
																			r.adjustedRegionalOpportunity,
																			0,
																			"$"
																	  )
																	: numberFormatter(
																			r.adjustedNationalOpportunity,
																			0,
																			"$"
																	  )}
															</td>
														</tr>
														{selectedRegions?.includes(
															r.Region
														) &&
															r.Districts.map(
																(
																	dis: any,
																	districtIndex: any
																) => {
																	return (
																		<tr
																			key={
																				d.material +
																				"_" +
																				r.Region +
																				"_" +
																				dis.District
																			}
																			className={`${
																				inputFlag ===
																				`${d.material}_${r.Region}_${dis.District}`
																					? "selected-row font-bold"
																					: ""
																			}`}
																		>
																			<td></td>
																			<td></td>
																			<td></td>
																			<td></td>
																			<td>
																				{
																					dis.District
																				}
																			</td>
																			<td>
																				{numberFormatter(
																					dis.LastYear_Qty,
																					0
																				)}
																			</td>
																			<td>
																				{numberFormatter(
																					dis.LastYear_Cost,
																					0,
																					"$"
																				)}
																			</td>
																			<td>
																				{numberFormatter(
																					dis.costPerUnit,
																					2,
																					"$"
																				)}
																			</td>
																			<td>
																				<input
																					type="text"
																					className="targetCostInput"
																					onInput={(
																						e
																					) => {
																						validateNumbers(
																							e
																						);
																					}}
																					value={
																						inputFlag ===
																						`${d.material}_${r.Region}_${dis.District}`
																							? targetCost
																							: props.target ===
																							  "regional"
																							? Number(
																									dis?.adjustedRegionalTargetCost
																							  )?.toFixed(
																									2
																							  )
																							: Number(
																									dis?.adjustedNationalTargetCost
																							  )?.toFixed(
																									2
																							  )
																					}
																					onChange={(
																						e
																					) => {
																						handleCostChange(
																							e,
																							materialIndex,
																							regionIndex,
																							districtIndex,
																							`${d.material}_${r.Region}_${dis.District}`
																						);
																					}}
																					// value={targetCost}
																				/>
																			</td>
																			<td>
																				{props.target ===
																				"regional"
																					? numberFormatter(
																							dis.adjustedRegionalOpportunity,
																							0,
																							"$"
																					  )
																					: numberFormatter(
																							dis.adjustedNationalOpportunity,
																							0,
																							"$"
																					  )}
																			</td>
																		</tr>
																	);
																}
															)}
													</>
												);
											}
										)}
								</React.Fragment>
							);
						}
					)}
					<tr className="total-row bottom-[4.4vw]">
						<td className="center">Total</td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						{/* <td></td> */}
						{props.selectedMaterial && <td></td>}
						{props.selectedRegions.length > 0 && <td></td>}
						<td></td>
						{/* {props.selectedRegions.length > 0 && <td></td>} */}
						<td>
							{numberFormatter(
								props.target === "regional"
									? totalOpp?.regionalOpp
									: totalOpp?.nationalOpp,
								0,
								"$"
							)}
						</td>
					</tr>
				</tbody>
			</table>
			<div className="pagination-components h-[15%] flex items-center justify-between">
				<Pagination
					prev
					next
					first
					last
					ellipsis
					boundaryLinks
					maxButtons={5}
					layout={["-", "pager", "skip"]}
					total={props.count}
					limit={limit}
					activePage={props.pageNumber}
					onChangePage={(e) => {
						props.updatePageNumber(e);
					}}
				/>

				{props.saveButton && (
					<div className="button-group flex gap-4 mr-2">
						<Button
							className="resetingButton"
							onClick={() => {
								props.handleReset();
								setInputFlag(null);
							}}
						>
							Reset
						</Button>
						<Button
							className="savingButton"
							onClick={() => {
								props.handleSave();
								setInputFlag(null);
							}}
						>
							Save
						</Button>
					</div>
				)}
			</div>
		</>
	);
};
export default MaterialTable;

{
	/* <div className="absolute">
					<Button
						className="bg-transparent hover:bg-transparent"
						onClick={exportExcel}
					>
						<FileDownloadIcon
							color="black"
							className="text-fsre15"
						/>
					</Button>
					<CSVLink
						ref={exportFullRef}
						data={exportData}
						headers={csvHeaders}
						filename="costOptimisation.csv"
						className="hidden"
						target="_blank"
					>
						{" "}
					</CSVLink>
					<CSVLink
						ref={exportFullRegionalRef}
						data={exportDataRegional}
						headers={csvHeadersRegional}
						filename="costOptimisationRegional.csv"
						className="hidden"
						target="_blank"
					>
						{" "}
					</CSVLink>
				</div> */
}
